<template>
  <div class="wrapper">
    <b-toast
      id="example-toast"
      hide-title
      auto-hide-delay="3000"
      header-class="header-toast-class"
      body-class="toast-body-class"
      toast-class="toast-class"
      toaster="b-toaster-top-center"
    >
      <font-awesome-icon icon="check-circle" class="mr-2"></font-awesome-icon
      >Copied
    </b-toast>
    <div class="container py-3">
      <div class="h1-title">ตอบกลับ</div>
      <div class="p-3 bg-white ticket-card mb-3">
        <div class="ticket-inner-card">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <div class="label-small">หมายเลขอ้างอิง</div>
              <div class="ticket-id">
                #{{ ticketDetail.ticket.id }}

                <font-awesome-icon
                  @click="copyTicketId(ticketDetail.ticket.id)"
                  icon="copy"
                  class="text-primary"
                ></font-awesome-icon>
              </div>
            </div>

            <div class="text-center">
              <div class="label-small">สถานะ</div>
              <b-badge pill class="status-pill" :class="statusClass">
                {{ statusText }}
              </b-badge>
            </div>
          </div>

          <div class="mt-3">
            <div class="label-small">หัวข้อ</div>
            <div class="subject-text">
              {{ ticketDetail.ticket.name || "-" }}
            </div>
          </div>

          <!-- <div class="row mt-3">
            <div class="col-6">
              <div class="label-small">เวลาที่สร้าง</div>
              <div class="text-small">
                {{ formatDate(ticketDetail.ticket.created_time) }}
              </div>
            </div>
            <div class="col-6 text-right">
              <div class="label-small">เวลาที่อัปเดต</div>
              <div class="text-small">
                {{ formatDate(ticketDetail.ticket.updated_time) }}
              </div>
            </div>
          </div>

          <hr class="my-3" />

          <div class="row">
            <div class="col-6">
              <div class="label-small">ประเภท</div>
              <div class="text-small">{{ ticketTypeText }}</div>
            </div>
          </div>

          <div class="mt-3">
            <div class="label-small">หมายเหตุเพิ่มเติม</div>
            <div
              class="comment-text clamp-3"
              v-html="ticketDetail.ticket.ticket_detail"
            ></div>
          </div>

          <div v-if="attachments.length" class="attachment-list mt-3">
            <div
              v-for="(f, i) in attachments"
              :key="'att-' + i"
              class="attachment-item"
              @click="openAttachment(f)"
            >
              <img
                v-if="isImage(f.url)"
                :src="f.url"
                class="attachment-img"
                alt=""
              />
              <template v-else-if="isVideo(f.url)">
                <video :src="f.url" width="300"></video>
                <div class="video-preview">
                  <font-awesome-icon icon="play"></font-awesome-icon>
                </div>
              </template>
              <div v-else class="attachment-file">
                <div>
                  <font-awesome-icon
                    :icon="getFileIcon(f.name)"
                  ></font-awesome-icon>
                </div>
                <div class="attachment-name">{{ f.name }}</div>
              </div>
            </div>
          </div> -->
        </div>
      </div>

      <!-- <div class="mt-4">
        <div class="h1-title">การตอบกลับ</div>

        <div
          v-if="activityList.length === 0"
          class="text-muted text-center py-4"
        >
          ยังไม่มีกิจกรรม
        </div>

        <div
          v-for="(a, i) in activityList"
          :key="'act-' + i"
          class="activity-bubble"
          :class="
            a.ticket_activity_type_id == 2 && a.ticket_action_id == 2
              ? 'customer'
              : 'admin'
          "
        >
          <div class="activity-head">
            <div class="activity-user">
              {{ a.name_created }}
              {{
                a.ticket_activity_type_id == 2 && a.ticket_action_id == 2
                  ? "(Customer)"
                  : "(Admin)"
              }}
            </div>
            <div class="activity-time">
              {{ fromNow(a.created_time) }}
              <span v-if="a.created_time">
                ({{ formatDate(a.created_time) }})
              </span>
            </div>
          </div>

          <hr class="activity-hr" />

          <div class="activity-msg" v-html="a.note"></div>
          <div v-if="a.attach_file.length" class="attachment-list mt-3">
            <div
              v-for="(f, i) in a.attach_file"
              :key="'att-' + i"
              class="attachment-item"
              @click="openAttachment(f)"
            >
              <img
                v-if="isImage(f.fileName)"
                :src="f.path"
                class="attachment-img"
                alt=""
              />
              <template v-else-if="isVideo(f.fileName)">
                <video :src="f.path" width="300"></video>
                <div class="video-preview">
                  <font-awesome-icon icon="play"></font-awesome-icon>
                </div>
              </template>

              <div v-else class="attachment-file">
                <div>
                  <font-awesome-icon
                    :icon="getFileIcon(f.fileName)"
                  ></font-awesome-icon>
                </div>
                <div class="attachment-name">{{ f.fileName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <TextEditorTiny
        textFloat=""
        :rows="4"
        :value="replyMessage"
        placeholder="Type something..."
        @onDataChange="(val) => (replyMessage = val)"
        @addFileAttachment="uploadFile"
        :defaultEdit="false"
        :isCustomer="true"
      >
      </TextEditorTiny>
      <div class="pb-footer-space"></div>
    </div>

    <div class="reply-footer">
      <div class="d-flex column-gap-lg">
        <template v-if="statusText == 'Close' || statusText == 'Resolve'">
          <div style="flex: 1">
            <b-button
              class="w-100"
              variant="custom-primary"
              style="min-width: unset; flex: 1"
              @click="goBack"
            >
              Back
            </b-button>
          </div>
        </template>
        <template v-else>
          <div>
            <b-button
              class="btn-cancel w-100"
              @click="goBack"
              variant="custom-outline-primary"
              style="flex: 1"
              >ยกเลิก</b-button
            >
          </div>
          <div style="flex: 1">
            <b-button
              class="w-100"
              variant="custom-primary"
              style="min-width: unset; flex: 1"
              @click="sendReply"
              :disabled="!replyMessage && attachFile.length == 0"
            >
              <font-awesome-icon icon="reply" class="mr-2"></font-awesome-icon>
              ตอบกลับ
            </b-button>
          </div>
        </template>
      </div>
    </div>
    <ModalConfirm
      ref="confirmModal"
      :text="'Close Ticket #' + activityBody.ticket_id"
      @handler="closeTicket"
      :button="{
        true: {
          class: ['btn-success'],
          msg: 'Confirm And Close',
          id: ['logout'],
        },
        false: {
          class: ['btn-danger'],
          msg: 'Cancel',
        },
      }"
    />
  </div>
</template>
<script>
import TextEditorTiny from "@/components/inputs/TextEditorsTiny";
import AddAttachmentModal from "@/components/ticket/AddAttachmentModal.vue";
import ModalConfirm from "@/components/modal/ModalConfirm";
const moment = require("moment");

export default {
  components: { AddAttachmentModal, ModalConfirm, TextEditorTiny },
  data() {
    return {
      isLoading: true,
      ticketId: 0,
      formDetail: {
        ticket_answer: [],
        form_field: [],
        ticket: {
          activity_source_id: 0,
          assign_to: "",
          created_by: "",
          created_time: "",
          id: 0,
          name: "",
          sla_status: 0,
          ticket_detail: "",
          ticket_form_id: 0,
          ticket_status_id: 0,
          ticket_type_id: 0,
          updated_by: "",
          updated_time: "",
          user_guid: "",
        },
        user_detail: {
          user_guid: null,
          name: null,
          member_id: null,
          telephone: null,
          email: null,
          member_tier: null,
          register_date: "0001-01-01T00:00:00",
          consent_status: null,
          is_connect: 0,
          is_company: 0,
          picture: null,
        },
      },
      ticketDetail: {
        ticket_answer: [],
        form_field: [],
        ticket: {
          activity_source_id: 0,
          assign_to: "",
          created_by: "",
          created_time: "",
          id: 0,
          name: "",
          sla_status: 0,
          ticket_detail: "",
          ticket_form_id: 0,
          ticket_status_id: 0,
          ticket_type_id: 0,
          updated_by: "",
          updated_time: "",
          user_guid: "",
        },
        user_detail: {
          user_guid: null,
          name: null,
          member_id: null,
          telephone: null,
          email: null,
          member_tier: null,
          register_date: "0001-01-01T00:00:00",
          consent_status: null,
          is_connect: 0,
          is_company: 0,
          picture: null,
        },
      },
      replyMessage: "",
      activityBody: {
        ticket_id: this.$route.params.ticketId,
        is_show_all_activity: 0,
        page: 0,
        take: 100,
        pageSize: 100,
      },
      activityList: [],
      attachFile: [],
      isReply: false,
    };
  },
  computed: {
    statusText() {
      const f = this.ticketDetail.form_field.find((x) => x.id === 623);

      return (
        f?.field_choice?.find(
          (e) => e.id == this.ticketDetail.ticket.ticket_status_id,
        )?.name ||
        f?.value ||
        "-"
      );
    },
    statusClass() {
      if (this.statusText === "Resolve") return "status-resolve";
      if (this.statusText === "In Progress") return "status-assign";
      if (this.statusText === "Close") return "status-close";
      return "status-open";
    },

    ticketTypeText() {
      const f = this.ticketDetail.form_field.find((x) => x.id === 624);

      return (
        f?.field_choice?.find(
          (e) => e.id == this.ticketDetail.ticket.ticket_type_id,
        )?.name ||
        f?.value ||
        "-"
      );
    },

    attachments() {
      const ans = this.ticketDetail.attach_file || [];
      const files = [];

      ans.forEach((a) => {
        const v = a?.path;
        if (!v) return;

        const urls = Array.isArray(v)
          ? v
          : String(v)
              .split(",")
              .map((x) => x.trim());
        urls.forEach((u) => {
          if (!u) return;
          const isImage = /\.(png|jpg|jpeg|webp|gif|heic|heif)$/i.test(u);
          files.push({
            url: u,
            name: u.split("/").pop(),
            isImage,
          });
        });
      });

      return files.slice(0, 10);
    },
  },
  watch: {
    replyMessage() {
      this.$nextTick(() => {
        this.autoResize();
      });
    },
  },
  async created() {
    this.ticketId = this.$route.params.ticketId;
    if (this.ticketId) {
      this.getFormDetail();
      this.getActivityDetail();
    }
    document.title = "Ticket Conversations";
  },
  methods: {
    async getFormDetail() {
      this.isLoading = true;

      const { data } = await this.axios(`/ticket/${this.ticketId}`);
      if (data.result === 1 && data.detail.form_field.length) {
        data.detail.form_field.forEach((element) => {
          element.field_dependent = this.mapFieldFromDepth(
            element.field_dependent,
            element.id,
          );
        });
        this.formDetail = data.detail;
        this.formDetail.form_field = await this.mappingValue(
          data.detail.form_field,
        );
        this.ticketDetail = { ...JSON.parse(JSON.stringify(this.formDetail)) };
      }
      this.isLoading = false;
    },
    mapFieldFromDepth(fields, parentId = null) {
      if (!fields?.length) return [];
      return fields
        .filter((el) => el.parent_id === parentId)
        .map((el) => {
          return {
            ...el,
            field_dependent: this.mapFieldFromDepth(
              fields,
              el.ticket_form_field_id,
            ),
          };
        });
    },

    async mappingValue(items, page = 1) {
      if (!items.length) return;
      const promises = items.map(async (el, index) => {
        if (items[index - 1] && items[index - 1].field_type_id == 14) {
          page = page + 1;
        }

        if (el.field_dependent?.length) {
          el.field_dependent = await this.mappingValue(
            el.field_dependent,
            page,
          );
        }

        const target = this.formDetail.ticket_answer.find(
          (ans) =>
            ans.ticket_form_field_id === (el.ticket_form_field_id || el.id),
        );

        let value = target?.value;
        let displayValue = "";
        let selectedValue = null;

        if (el.ticket_field_id === 1 && value) {
          const customer = this.formDetail.user_detail;
          if (customer) {
            displayValue = [customer?.name, customer?.telephone]
              .filter((el) => el)
              .join(", ");

            selectedValue = {
              ...this.formDetail.user_detail,
            };
          }
        } else if (el.field_type_id === 2) {
          value = value ? value.split(",") : [];
        } else if (el.field_type_id === 3 && value) {
          let defaultValue = value.split(",");
          value = el.field_choice.filter((el) =>
            defaultValue.includes(el.id.toString()),
          );
        } else if (el.ticket_field_id === 6 && value) {
          let defaultValue = value.split(",");
          value = el.field_choice.find((el) =>
            defaultValue.includes(el.id.toString()),
          );
        }

        return {
          ...el,
          value: value || null,
          displayValue,
          selectedValue,
          answerId: target?.id || 0,
          isActive: false,
          page: page,
        };
      });

      const allResults = await Promise.all(promises);
      return allResults;
    },

    formatDate(d) {
      if (!d) return "-";
      return moment(d).format("DD MMM YYYY HH:mm");
    },
    fromNow(d) {
      if (!d) return "";
      return moment(d).fromNow();
    },

    triggerFile() {
      this.$refs["attachments-modal"].toggle();
    },
    async sendReply() {
      try {
        if (!this.replyMessage && this.attachFile.length == 0) return;
        this.$bus.$emit("showLoading");

        const { data } = await this.axios.post(`/ticket/activity`, {
          id: 0,
          ticket_id: this.ticketId,
          ticket_activity_type_id: 2,
          note: this.replyMessage,
          ref_id: 0,
          deleted: 0,
          attach_file: [
            ...this.attachFile.map((el) => ({ fileName: el.name, ...el })),
          ],
          email: "",
          user_guid: this.$route.query.user_guid,
        });
        window.parent.postMessage(
          {
            type: "onReply",
            data: {
              id: 0,
              ticket_id: this.ticketId,
              ticket_activity_type_id: 2,
              note: this.replyMessage,
              ref_id: 0,
              deleted: 0,
              attach_file: [
                ...this.attachFile.map((el) => ({ fileName: el.name, ...el })),
              ],
              email: "",
              user_guid: this.$route.query.user_guid,
            },
          },
          this.$parentOrigin,
        );

        if (data.result == 1) {
          this.isReply = false;
          this.replyMessage = "";
          this.attachFile = [];
          this.successAlert();
          this.$router.replace("/customer/ticket/" + this.ticketId);
        } else this.errorAlert(data.message);
        this.getActivityDetail();
      } catch (error) {
        this.errorAlert(error.message);
      } finally {
        this.$bus.$emit("hideLoading");
      }
    },
    openAttachment(f) {
      if (!f?.url && !f.path) return;
      window.open(f.url || f.path, "_blank");
    },
    getFileIcon(name) {
      if (name.includes(".xlsx")) return "file-excel";
      return "file-download";
    },
    async getActivityDetail() {
      const { data } = await this.axios.post(
        `/ticket/activity/detail`,
        this.activityBody,
      );

      this.activityList = data.detail.data;
    },
    autoResize() {
      const el = this.$refs.replyTextarea;
      if (!el) return;

      el.style.height = "auto";
      el.style.height = el.scrollHeight + "px";
    },
    uploadFile(value) {
      this.attachFile = value;
    },
    async closeTicket(value) {
      if (!value) return;
      try {
        this.$bus.$emit("showLoading");
        const field_answer = this.flatFields(this.ticketDetail.form_field);
        let file = this.ticketDetail.attach_file.map((el) => {
          return { fileName: el.name, path: el.path };
        });
        const ticket = field_answer.find(
          (answer) => answer.name == "RelatedTicket",
        );
        const status = field_answer.findIndex((answer) => answer.id == "623");
        field_answer[status].value = "4";

        const relatedTicketValue = ticket
          ? ticket.rawValue.map((answer) => {
              return {
                id: answer.id,
                ticket_relate_type_id: answer.ticket_relate_type_id,
                ticket_relate_ref_id: answer.ticket_relate_ref_id,
              };
            })
          : [];
        const payload = {
          id: this.$route.params.ticketId,
          ticket_form_id: 1,
          field_answer,
          is_send_mail_customer: false,
          attach_file: file.length == 0 ? null : file,
          ticket_relate_list: relatedTicketValue,
        };

        const { data } = await this.axios.post(`/ticket`, payload);
        if (data.result == 1) {
          this.isLoading = false;

          this.$router.replace("/customer/ticket/close/" + this.ticketId);
        } else {
          this.isLoading = false;
          this.errorAlert(data.message);
        }
      } catch (error) {
        this.errorAlert(error.message);
      } finally {
        this.$bus.$emit("hideLoading");
      }
    },
    flatFields(data) {
      return data.map((el) => ({
        ...el,
        value:
          el.field_type_id == 3
            ? el?.value?.map((item) => item.id).join(",") || ""
            : el?.value?.id
            ? String(el.value.id)
            : el.value,
      }));
    },
    showConfirmModal() {
      this.$refs.confirmModal.show();
    },
    goBack() {
      this.$router.push({
        path: "/customer/ticket/" + this.$route.params.ticketId,
        query: this.$route.query,
      });
    },
    async copyTicketId(ticketId) {
      await this.copyToClipboard(ticketId);
      this.$bvToast.show("example-toast");
    },
    async copyToClipboard(text) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = text;
          textarea.style.position = "fixed";
          textarea.style.left = "-999999px";
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          document.execCommand("copy");
          textarea.remove();
        }
        return true;
      } catch (err) {
        console.error("Copy failed", err);
        return false;
      }
    },
    isImage(u) {
      return /\.(png|jpg|jpeg|webp|gif|heic|heif)$/i.test(u);
    },
    isVideo(u) {
      return /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(u);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .text-float-normal .input-custom {
  label {
    color: #5b5b5b;
    font-size: 16px;
    font-weight: 100;
  }
}

.activity-form {
  background-color: white;
  position: relative;
  border-radius: 0.75rem;

  .btn-save {
    width: 100%;
  }
}

.btn-save {
  width: auto;
}

#footer {
  position: fixed;
  bottom: 0;
  left: 256px;
  right: 0;
  height: 10%;
  padding: 15px;
  background: #fff;
}

.badge-new {
  background-color: rgb(39, 189, 167);
  color: white;
  padding: 0.4em 0.6em;
}

::v-deep .header-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

::v-deep .header-tablepage {
  margin: 0 !important;
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .pagination-action {
    display: flex;
    gap: 8px;
    align-items: center;
  }
}

.w-100px {
  width: 101px !important;
  min-width: 0 !important;
}
.wrapper {
  background-color: whitesmoke;
  height: 100dvh;
  overflow-y: auto;
}
.title-ticket {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 1rem;
}
.activity-card-list {
  border-radius: 10px;
  padding: 8px;
  border: 1px solid #dadada;
}
.h1-title {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 14px;
}

.ticket-card {
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
}

.label-small {
  font-size: 11px;
  letter-spacing: 0.04em;
  color: #9aa0aa;
  font-weight: 700;
}

.ticket-id {
  font-weight: 800;
  font-size: 16px;
}

.priority-dot {
  width: 10px;
  height: 10px;
  background: #7e3af2;
  display: inline-block;
  border-radius: 4px;
  margin-left: 6px;
  transform: translateY(1px);
}

.subject-text {
  font-size: 16px;
  font-weight: 600;
  color: #2b2f38;
}

.text-small {
  font-size: 13px;
  color: #4a5160;
}

.status-pill {
  font-weight: 700;
  padding: 6px 12px;
  font-size: 12px;
}

.status-assign {
  border: 1px solid #ff9f43;
  color: #ff9f43;
  background: transparent;
}
.status-resolve {
  background: #27bda6;
  color: white;
  /* background: transparent; */
}
.status-open {
  border: 1px solid rgba(20, 184, 166, 0.35);
  background: rgba(45, 212, 191, 0.12);
  color: #14b8a6;
}

.status-close {
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(148, 163, 184, 0.18);
  color: #94a3b8;
}

.comment-text {
  color: #667085;
  font-size: 13px;
}

.clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* attachments */
.attachment-list {
  display: flex;
  gap: 10px;
  overflow-x: auto;
  padding-bottom: 6px;
}
video {
  width: 100%;
  height: 100%;
}

.attachment-item {
  min-width: 92px;
  cursor: pointer;
  max-width: 100px;
  max-height: 100px;
  position: relative;
}

.attachment-img {
  width: 92px;
  height: 100px;
  object-fit: cover;
  border-radius: 10px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.attachment-file {
  width: 92px;
  height: 100px;
  border-radius: 10px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  align-content: center;
  text-align: center;
  padding: 6px;
  font-size: 24px;
  color: #4a5160;
}

.attachment-name {
  white-space: revert;
  word-break: break-all;
  font-size: 10px;
}

.dots-indicator {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
}
.dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #d0d5dd;
}
.dot.active {
  background: #7e3af2;
}

/* Activities bubble */
.activity-bubble {
  padding: 16px;
  border-radius: 18px;
  margin-bottom: 16px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
}
.activity-bubble.admin {
  background: #e8ddf3;
}
.activity-bubble.customer {
  background-color: white;
}

.activity-head {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.activity-user {
  font-weight: 800;
  color: #2b2f38;
}

.activity-time {
  font-size: 12px;
  color: #6b7280;
}

.activity-hr {
  margin: 10px 0;
}

.activity-msg {
  word-break: break-word;
}

.reply-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 12px;

  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.08);
}
.reply-footer-panel {
  display: flex;
  gap: 10px;
  align-items: center;
}
.reply-input {
  flex: 1;
  border-radius: 4px;
  border-color: whitesmoke;
  align-content: center;
  padding-inline-start: 1rem;
  background-color: whitesmoke;
  max-height: 160px;
  overflow-y: auto;
  resize: none;
}

.attach-btn {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(126, 58, 242, 0.35);
  color: #7e3af2;
}

.send-btn {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #7e3af2;
  border: none;
}

.pb-footer-space {
  height: 84px;
}
::v-deep .header-toast-class {
  display: none !important;
}
::v-deep .toast-class {
  max-width: max-content;
  margin: auto;
  border-radius: 1rem;
  padding: 0 15px;
  background-color: white !important;
  border: 1px solid white;
  box-shadow: 2px 3px 15px 5px rgba(0, 0, 0, 0.24);
}
::v-deep .toast-body-class {
  padding: 0.5rem !important;
  color: green;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
